import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Testimonial } from '../../types';

interface AvatarGroupProps {
  testimonials: Testimonial[];
  activeIndex: number;
}

const AvatarGroup: React.FC<AvatarGroupProps> = ({ testimonials, activeIndex }) => {
  const { t } = useTranslation();

  const total = testimonials.length;
  const slots: { key: string; testimonial: Testimonial; isActive: boolean }[] = [
    {
      key: 'left',
      testimonial: testimonials[(activeIndex - 1 + total) % total],
      isActive: false,
    },
    {
      key: 'center',
      testimonial: testimonials[activeIndex],
      isActive: true,
    },
    {
      key: 'right',
      testimonial: testimonials[(activeIndex + 1) % total],
      isActive: false,
    },
  ];

  return (
    <div className="mb-1 flex items-center justify-center gap-2 sm:gap-3">
      {slots.map(({ key, testimonial, isActive }) => (
        <div
          key={key}
          className={clsx(
            'relative flex-shrink-0',
            isActive ? 'w-8 h-8' : 'w-[40px] h-[40px] sm:w-7 sm:h-7'
          )}
        >
          <img
            src={testimonial.avatar}
            alt={isActive ? t(testimonial.nameKey) : ''}
            className={clsx(
              'h-full w-full rounded-full object-cover',
              isActive ? 'opacity-100' : 'opacity-40'
            )}
            loading="lazy"
          />
        </div>
      ))}
    </div>
  );
};

export { AvatarGroup };
